import Store from './Store';

const SWParamsStore = new Store('swparams');

export {SWParamsStore};